// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"96e3482e","402":"5b13a8ad","484":"d01d4c83","649":"91b6a335","881":"80c52e8f"}[chunkId] + ".chunk.css";
};